export const REGIONS = {
    NorthAmerica: "ჩრდილოეთ ამერიკა",
    SouthAmerica: "სამხრეთ ამერიკა",
    Europe: "ევროპა",
    Oceania: "ოკეანია",
    Asia: "აზია"
}